// extracted by css-extract-rspack-plugin
export default {"actionListTitle":"IssueTemplateItem-module__actionListTitle__gKiCclV","templateItemContainer":"IssueTemplateItem-module__templateItemContainer__GYh3QOq"};